import Model, { Integer, IsoDateTime, JsonObject } from 'src/models/Model'
import CleanTask from 'src/models/planning/CleanTask'
import { timeToMinutes } from 'src/models/schedule/TimeSlot'

export const ARRIVE_CHART_WIDTH = 91

export default class TaskPlanning extends Model {
  static name = 'TaskPlanning'

  static noId = true

  static define () {
    this.fields = {
      startTime: {
        type: IsoDateTime
      },
      totalMinutes: {
        type: Integer
      },
      arriveSeries: {
        type: [Number]
      },
      employeeDemandSeries: {
        type: [Number]
      },
      registerEmployeeDemandSeries: {
        type: [Number]
      },
      cleaningEmployeesSeries: {
        type: [Number]
      },
      cleanTasks: {
        type: [CleanTask]
      },
      arriveSeriesByShowingId: {
        type: JsonObject
      },
      arriveSeriesByShowingStartMinute: {
        type: JsonObject
      },
      serviceRate: {
        type: Number
      }
    }

    this.computed = {
      startTimeMinutes () {
        return timeToMinutes(this.startTime)
      },
      siteStartTime () {
        return new IsoDateTime(this.startTime).inTimeZone(this.configuration.currentSite.timeZone)
      }
    }

    this.queries = {
      taskPlanningForDate: {
        arguments: {
          date: {
            type: String,
            required: true
          },
          options: {
            type: JsonObject,
            required: false
          }
        },
        results: {
          report: TaskPlanning
        }
      }
    }
  }
}
